import { Injectable, WritableSignal, signal } from '@angular/core';

import { AppSettingsService } from '@core/services/app-settings/app-settings.service';
import { ProductsService } from '@core/services/products/products.service';

import { BaseProfileCommand } from '@shared/commands/base-profile.command';
import { IProfileCommandContext } from '@shared/models/profile-command.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable()
export class EnableBlockedProductsCommand extends BaseProfileCommand {
  public readonly checkbox = 'checked' as const;
  public readonly group = 'display';
  public readonly hidden = false;
  public readonly icon = 'eye-open';
  public readonly order = 1;
  public readonly settingsNames?: string[] = undefined;
  public readonly subtitle?: WritableSignal<string> = undefined;
  public readonly title = 'Отображать заблокированные продукты';
  public readonly type = 'enableBlockedProducts';
  readonly checkboxChecked = signal(false);
  readonly checkboxDisabled = signal(false);

  constructor(
    private productsService: ProductsService,
    commandAvailabilityService?: CommandAvailabilityService,
    appSettingsService?: AppSettingsService
  ) {
    super(commandAvailabilityService, appSettingsService);
    // Синхронно подтянем сохранённое состояние из кэша (после APP_INITIALIZER)
    if (this.appSettingsService) {
      const saved = this.appSettingsService.getSettingSync<boolean | string>(this.type);

      if (saved !== null) {
        const enabled = typeof saved === 'string' ? saved === '1' || saved === 'true' : Boolean(saved);

        this.updateCheckboxState(enabled);
      }
    }
  }

  public async execute(_context: IProfileCommandContext): Promise<void> {
    console.log('EnableBlockedProductsCommand.execute - before:', this.checkboxChecked);
    console.log('EnableBlockedProductsCommand.execute - type:', this.type);

    // Используем базовое переключение чекбокса с автоматическим сохранением
    const newState = await this.executeToggle();

    console.log('EnableBlockedProductsCommand.execute - after:', this.checkboxChecked, 'newState:', newState);

    // Добавляем недостающую логику обновления продуктов
    this.productsService.refreshProducts$.next(true);

    console.log(`Blocked products display ${newState ? 'enabled' : 'disabled'}`);

    // Проверим что реально сохранилось (через базовый getSetting)
    const savedValue = await this.getSetting<boolean | string>();
    const savedBool =
      typeof savedValue === 'string' ? savedValue === '1' || savedValue === 'true' : Boolean(savedValue);

    console.log('EnableBlockedProductsCommand.execute - saved value:', savedValue, 'as bool:', savedBool);
  }

  /**
   * Переключает состояние чекбокса (вызывается при клике на чекбокс)
   */
  public async toggle(): Promise<void> {
    console.log('EnableBlockedProductsCommand.toggle called');
    await this.execute({ data: {} });
  }
}
